import QuillEditor from "../util/QuillEditor";
import styles from "./PageEdit.module.css"
import ImageSelector from "./ImageSelector";

// component
import TextInput from "./TextInput";

export default function PageInfoListItemEdit({setImage, sectionKey, title, id, text, subTitle, subText, imageUrl, updateField, parentSectionKey}) {

    return(
       <div className={styles.item}>
            <h3>{title}</h3>
            {/* Header Input */}
            <TextInput
                label={"Header:"}
                value={title}
                onChange={(e) => updateField(parentSectionKey, sectionKey+".title", e.target.value)}
            />

            <TextInput
                label={"Id:"}
                value={id}
                onChange={(e) => updateField(parentSectionKey, sectionKey+"id", e.target.value)}
            />

            {/* Content Editor */}
            <QuillEditor
                value={text || ""}
                onChange={(value) => updateField(parentSectionKey, sectionKey+".text", value)}
                placeholder="Write your content here..."
            />

            {setImage ?( <ImageSelector 
                            value={imageUrl || ""}
                            updateField={(val) => updateField(parentSectionKey, sectionKey+".imageUrl", val)}
                        />): null}

            {/* Sub Header Input */}
            <TextInput
                label={"Sub Header:"}
                value={subTitle}
                onChange={(e) => updateField(parentSectionKey, sectionKey+".subTitle", e.target.value)}
            />

            {/* Sub Text Input */}
            <QuillEditor
                value={subText || ""}
                onChange={(value) => updateField(parentSectionKey, sectionKey+".subText", value)}
                placeholder="Write your content here..."
            />
       </div> 
    );
}